import { GET_IPM_DATA, GET_IPM_GROUP_DATA } from './../constants/actionTypes'
import get from 'lodash/get'

const ipmDuties = (store = [], action = {}) => {
  switch (action.type) {
    case GET_IPM_DATA:
      return get(action, 'data', [])
    default:
      return store
  }
}
const ipmGroup = (store = [], action = {}) => {
  switch (action.type) {
    case GET_IPM_GROUP_DATA:
      return get(action, 'data.data.ipmDutyGroups', [])
    default:
      return store
  }
}

export { ipmDuties,ipmGroup }
